import { createReducer, on } from '@ngrx/store';
import { QuickRepliesState, initialQuickRepliesState } from '../State/quick-replies.state';
import * as QuickRepliesActions from '../Actions/quick-replies.action';

export const quickRepliesReducer = createReducer(
  initialQuickRepliesState,
  on(QuickRepliesActions.updateQuickForm, (state, { formData }) => ({
    ...state,
    formData
  })),
  on(QuickRepliesActions.goToNextQuickResponse, (state, { nextResponse }) => ({
    ...state,
    nextResponse
  })),
  on(QuickRepliesActions.resetQuickRepliesState, state => ({
    ...state,
    formData: null,
    nextResponse: null
  }))
);  